import { pinImageSources } from '@/features/orders/components/MapPanel/parts/Content/parts/Map/constants/pinImageSources'
import { pinLogicalWidth } from '@/features/orders/components/MapPanel/parts/Content/parts/Map/constants/pinStyle'
import { Asset } from 'expo-asset'
import type mapboxgl from 'mapbox-gl'

export const registerPinImages = async (map: mapboxgl.Map, signal: AbortSignal) => {
    if (signal.aborted) return

    await Promise.all(
        Object.entries(pinImageSources).map(([name, imageSource]) => {
            const uri = Asset.fromModule(imageSource).uri

            return new Promise<void>((resolve, reject) => {
                map.loadImage(uri, (error, image) => {
                    if (signal.aborted) return resolve()

                    if (error || !image) {
                        return reject(error ?? new Error(`Missing map pin: ${name}`))
                    }

                    map.addImage(name, image, { pixelRatio: image.width / pinLogicalWidth })
                    resolve()
                })
            })
        })
    )
}
